import API from "./interceptor";


// ******************* Create a new supplier *******************
export const createSupplier = async (supplierData) => {
  try {
    const response = await API.post('/api/suppliers', supplierData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to create supplier"
    );
  }
};

// ******************* Get all suppliers *******************
export const getAllSuppliers = async (params = {}) => {
  try {
    const response = await API.get('/api/suppliers', { params });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch suppliers"
    );
  }
};

// ******************* Get supplier by ID *******************
export const getSupplierById = async (id) => {
  try {
    const response = await API.get(`/api/suppliers/${id}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch supplier"
    );
  }
};

// ******************* Update supplier *******************
export const updateSupplier = async (id, supplierData) => {
  try {
    const response = await API.put(`/api/suppliers/${id}`, supplierData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to update supplier"
    );
  }
};

// ******************* Delete supplier (soft delete) *******************
export const deleteSupplier = async (id) => {
  try {
    const response = await API.delete(`/api/suppliers/${id}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to delete supplier"
    );
  }
};

// ******************* Permanently delete supplier *******************
export const permanentDeleteSupplier = async (id) => {
  try {
    const response = await API.delete(`/api/suppliers/${id}/permanent`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to permanently delete supplier"
    );
  }
};

// ******************* Activate supplier *******************
export const activateSupplier = async (id) => {
  try {
    const response = await API.patch(`/api/suppliers/${id}/activate`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to activate supplier"
    );
  }
};

// ******************* Get supplier statistics *******************
export const getSupplierStats = async () => {
  try {
    const response = await API.get('/api/suppliers/stats');
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch supplier statistics"
    );
  }
};

// ******************* Bulk operations on suppliers *******************
export const bulkOperations = async (operation, supplierIds) => {
  try {
    const response = await API.post('/api/suppliers/bulk', {
      operation,
      supplierIds
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to perform bulk operation"
    );
  }
};

// ******************* Fetch suppliers by name (search) *******************
export const fetchSuppliersByName = async (name, params = {}) => {
  try {
    const response = await API.get('/api/suppliers', {
      params: { search: name, ...params }
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch suppliers by name"
    );
  }
};

// ******************* Fetch suppliers by status *******************
export const fetchSuppliersByStatus = async (isActive, params = {}) => {
  try {
    const response = await API.get('/api/suppliers', {
      params: { isActive, ...params }
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch suppliers by status"
    );
  }
};

// ******************* Fetch suppliers by payment terms *******************
export const fetchSuppliersByPaymentTerms = async (paymentTerms, params = {}) => {
  try {
    const response = await API.get('/api/suppliers', {
      params: { paymentTerms, ...params }
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch suppliers by payment terms"
    );
  }
};

// ******************* Fetch active suppliers only *******************
export const fetchActiveSuppliers = async (params = {}) => {
  try {
    const response = await API.get('/api/suppliers', {
      params: { isActive: true, ...params }
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch active suppliers"
    );
  }
};

// ******************* Fetch suppliers with pagination *******************
export const fetchSuppliersWithPagination = async (page = 1, limit = 10, params = {}) => {
  try {
    const response = await API.get('/api/suppliers', {
      params: { page, limit, ...params }
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch suppliers with pagination"
    );
  }
};